import { useEffect } from 'react';

import { animate } from 'motion/react';

const HIGHLIGHT_COLOR = 'rgba(78, 24, 187, 0.14)';

export const useHighlightFlash = (ref, token) => {
  useEffect(() => {
    const element = ref.current;
    if (!token || !element) return;

    const baseColor = getComputedStyle(element).backgroundColor;
    const restingColor = baseColor === 'rgba(0, 0, 0, 0)' ? 'rgba(78, 24, 187, 0)' : baseColor;
    const animation = animate(
      element,
      { backgroundColor: [HIGHLIGHT_COLOR, restingColor] },
      { duration: 1.6, ease: 'easeOut' },
    );

    return () => animation.stop();
  }, [token]);
};
